/* The Warm Chapter: buy-box offer logic.
   - size buttons (pair 1 drives the variant, every pair is sent as a line property)
   - one-tap add-on with a REAL per-shopper offer window (no resetting timer)
   - add to cart -> opens the theme's cart drawer (Horizon) instead of the /cart page
   - socks "second chance" card in the drawer / cart page ([data-twc-offer])
   Runs before twc.js's generic [data-atc] handler (capture phase). */
(function () {
  'use strict';
  if (window.__twcOffer) return;
  window.__twcOffer = true;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var DEAL_KEY = 'twc_socks_deal';
  var COOLDOWN = 7 * 864e5; // after expiry the offer stays gone for this browser for 7 days

  function fmt(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2) + ' ' + cur; }
  }

  // ---------------------------------------------------------------- real offer window
  function readDeal() { try { return JSON.parse(localStorage.getItem(DEAL_KEY) || 'null'); } catch (e) { return null; } }
  function writeDeal(d) { try { localStorage.setItem(DEAL_KEY, JSON.stringify(d)); } catch (e) {} }
  /** Starts the window the first time an offer is shown. Returns ms left (0 = expired). */
  function dealLeft(minutes) {
    var d = readDeal(), now = Date.now();
    if (!d || now > d.until + COOLDOWN) { d = { until: now + minutes * 60000 }; writeDeal(d); }
    return Math.max(0, d.until - now);
  }
  function dealOpen() { var d = readDeal(); return !!d && Date.now() < d.until; }
  var dealMinutes = 10;

  function clockText(ms) {
    var s = Math.ceil(ms / 1000), m = Math.floor(s / 60), r = s % 60;
    return (m < 10 ? '0' : '') + m + ':' + (r < 10 ? '0' : '') + r;
  }

  function showOffers() {
    var timed = document.querySelectorAll('[data-addon][data-timed], [data-twc-offer]');
    if (!timed.length) return;
    var pdp = document.querySelector('[data-addon][data-timed]');
    if (pdp) dealMinutes = parseInt(pdp.getAttribute('data-timed'), 10) || 10;
    var left = dealLeft(dealMinutes);
    timed.forEach(function (el) {
      if (el.hasAttribute('data-in-cart')) { el.hidden = false; return; }
      if (left > 0) el.hidden = false;
      else expire(el);
    });
  }
  function expire(el) {
    el.hidden = true;
    var c = el.querySelector('[data-addon-check]');
    if (c && c.checked) { c.checked = false; var sc = el.closest('[data-buy-scope]'); if (sc) refreshTotal(sc); }
  }
  setInterval(function () {
    var d = readDeal();
    if (!d) return;
    var left = Math.max(0, d.until - Date.now());
    document.querySelectorAll('[data-offer-clock]').forEach(function (c) { c.textContent = clockText(left); });
    if (!left) document.querySelectorAll('[data-addon][data-timed], [data-twc-offer]:not([data-in-cart])').forEach(expire);
  }, 1000);

  // ---------------------------------------------------------------- PDP buy box
  function selectedTier(scope) { return scope.querySelector('[data-option].is-selected') || scope.querySelector('[data-option]'); }

  function refreshTotal(scope) {
    var tier = selectedTier(scope);
    if (!tier) return;
    var extra = 0;
    scope.querySelectorAll('[data-addon]').forEach(function (a) {
      var c = a.querySelector('[data-addon-check]');
      var on = !!(c && c.checked && !a.hidden);
      a.classList.toggle('is-on', on);
      if (on) extra += parseInt(a.getAttribute('data-cents') || '0', 10);
    });
    var out = scope.querySelector('[data-price-out]'), cmp = scope.querySelector('[data-compare-out]');
    var sp = document.querySelector('[data-sticky-price]'), sc = document.querySelector('[data-sticky-compare]');
    if (!extra) {
      // back to the tier's own price (twc.js format)
      var p = tier.getAttribute('data-price-money'), c2 = tier.getAttribute('data-compare-money') || '';
      if (out && p) out.textContent = p;
      if (sp && p) sp.textContent = p;
      if (cmp) { cmp.textContent = c2; cmp.style.display = c2 ? '' : 'none'; }
      if (sc) { sc.textContent = c2; sc.style.display = c2 ? '' : 'none'; }
      return;
    }
    var total = fmt(parseInt(tier.getAttribute('data-cents') || '0', 10) + extra);
    if (out) out.textContent = total;
    if (sp) sp.textContent = total;
    if (cmp) cmp.style.display = 'none';
    if (sc) sc.style.display = 'none';
  }

  document.querySelectorAll('[data-buy-scope]').forEach(function (scope) {
    scope.querySelectorAll('[data-size-group]').forEach(function (g) {
      g.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-size-btn]');
        if (!btn || btn.disabled) return;
        e.stopPropagation();
        g.querySelectorAll('[data-size-btn]').forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('is-on', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        var opt = g.closest('[data-option]');
        if (opt && g.getAttribute('data-pair') === '1') {
          opt.setAttribute('data-variant', btn.getAttribute('data-value'));
          if (opt.classList.contains('is-selected')) {
            var atc = scope.querySelector('[data-atc]');
            if (atc) atc.setAttribute('data-variant', btn.getAttribute('data-value'));
          }
        }
      });
    });
    scope.querySelectorAll('.szp__help').forEach(function (d) { d.addEventListener('click', function (e) { e.stopPropagation(); }); });
    scope.querySelectorAll('[data-addon-check]').forEach(function (c) { c.addEventListener('change', function () { refreshTotal(scope); }); });
    scope.querySelectorAll('[data-option]').forEach(function (o) {
      o.addEventListener('click', function () { setTimeout(function () { refreshTotal(scope); }, 0); });
    });
    refreshTotal(scope);
  });

  // ---------------------------------------------------------------- cart: add + code + drawer
  function api(path, body) {
    return fetch(ROOT + path, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Cart error'); return j; });
    });
  }
  var SECTION = 'cart-drawer-section';
  function drawerEl() { return document.getElementById('cart-drawer'); }

  /** Swap in fresh drawer markup returned by the cart API (one request, no extra render call). */
  function redraw(sections) {
    var drawer = drawerEl(), html = sections && sections[SECTION];
    if (!drawer || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('.cart-drawer__inner'), old = drawer.querySelector('.cart-drawer__inner');
    if (fresh && old) old.replaceWith(document.importNode(fresh, true));
    perksLast();
    var css = doc.querySelector('style[data-section-stylesheet]'), wrap = document.getElementById('shopify-section-' + SECTION);
    if (css && wrap && !wrap.querySelector('style[data-section-stylesheet]')) wrap.prepend(document.importNode(css, true));
    showOffers();
  }
  function busy(on) {
    var d = drawerEl();
    if (!d) return;
    d.classList.toggle('twc-loading', on);
    if (on && !d.isOpen && typeof d.open === 'function') d.open(); // open instantly, fill when the cart answers
  }
  function done(res) {
    busy(false);
    if (!drawerEl()) { window.location.href = ROOT + 'cart'; return res; }
    redraw(res && res.sections);
    return res;
  }

  // ---------------------------------------------------------------- included-free perks
  // $0 hidden products (warranty, parcel cover, size swap) that ride along with the gloves.
  var PERKS = [51075907813601, 51075907977441, 51075908075745];
  var GLOVES = ['rechargeable-heated-gloves', 'heated-gloves-2-pairs'];
  var perkTimer = null;
  /** Keep exactly one of each perk while gloves are in the cart, none otherwise. Runs in the background. */
  function syncPerks(cart) {
    var get = cart ? Promise.resolve(cart) : api('cart.js');
    return get.then(function (c) {
      var hasGloves = c.items.some(function (i) { return GLOVES.indexOf(i.handle) > -1; });
      var qty = {};
      c.items.forEach(function (i) { if (PERKS.indexOf(i.variant_id) > -1) qty[i.variant_id] = (qty[i.variant_id] || 0) + i.quantity; });
      var updates = {}, changed = false;
      PERKS.forEach(function (id) {
        var want = hasGloves ? 1 : 0;
        if ((qty[id] || 0) !== want) { updates[id] = want; changed = true; }
      });
      if (!changed) return null;
      return api('cart/update.js', { updates: updates, sections: drawerEl() ? SECTION : undefined }).then(function (res) {
        if (drawerEl()) redraw(res.sections);
        else if (/\/cart\/?$/.test(location.pathname)) location.reload();
        return res;
      });
    }).catch(function () {});
  }
  /** Perk lines always sit under the real products. */
  function perksLast() {
    var body = document.querySelector('#cart-drawer .cart-items__table tbody');
    if (!body) return;
    var rows = Array.prototype.slice.call(body.children);
    var perks = rows.filter(function (r) { return r.classList.contains('twc-perk-row'); });
    if (!perks.length) return;
    var firstPerk = rows.indexOf(perks[0]);
    if (rows.slice(firstPerk).every(function (r) { return r.classList.contains('twc-perk-row'); })) return;
    perks.forEach(function (r) { body.appendChild(r); });
  }
  function syncPerksSoon() { clearTimeout(perkTimer); perkTimer = setTimeout(function () { syncPerks(); }, 350); }

  /** Add lines (+ apply `code`, keeping codes already on the cart) and redraw the drawer. 1–2 requests. */
  function addToCart(items, code) {
    var withDrawer = !!drawerEl();
    busy(true);
    var run;
    if (code) {
      run = Promise.all([api('cart/add.js', { items: items }), api('cart.js')]).then(function (r) {
        var codes = (r[1].discount_codes || []).map(function (d) { return d.code; });
        if (codes.map(function (c) { return c.toUpperCase(); }).indexOf(code.toUpperCase()) < 0) codes.push(code);
        return api('cart/update.js', { discount: codes.join(','), sections: withDrawer ? SECTION : undefined });
      });
    } else {
      run = api('cart/add.js', { items: items, sections: withDrawer ? SECTION : undefined });
    }
    return run.then(done, function (err) { busy(false); throw err; });
  }
  function removeLine(key) {
    busy(true);
    return api('cart/change.js', { id: key, quantity: 0, sections: drawerEl() ? SECTION : undefined })
      .then(function (res) { if (!drawerEl()) { window.location.reload(); return res; } return done(res); },
            function (err) { busy(false); throw err; });
  }

  // PDP add to cart
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-atc]');
    if (!btn) return;
    var scope = btn.closest('[data-buy-scope]');
    if (!scope) {
      if (!btn.closest('[data-sticky-atc]')) return;
      scope = document.querySelector('[data-buy-scope]');
      if (!scope) return;
    }
    var tier = selectedTier(scope);
    if (!tier) return;
    e.preventDefault();
    e.stopImmediatePropagation();

    var props = {};
    var groups = tier.querySelectorAll('[data-size-group]');
    if (groups.length > 1) {
      groups.forEach(function (g) {
        var on = g.querySelector('[data-size-btn].is-on');
        if (on) props['Pair ' + g.getAttribute('data-pair') + ' size'] = on.getAttribute('data-title');
      });
    }
    var items = [{ id: Number(tier.getAttribute('data-variant')), quantity: parseInt(tier.getAttribute('data-qty') || '1', 10), properties: props }];
    var code = null;
    scope.querySelectorAll('[data-addon]').forEach(function (a) {
      var c = a.querySelector('[data-addon-check]');
      if (!c || !c.checked || a.hidden) return;
      if (a.hasAttribute('data-timed') && !dealOpen()) return; // the window closed: no discounted add
      items.push({ id: Number(a.getAttribute('data-variant')), quantity: 1 });
      if (a.getAttribute('data-code')) code = a.getAttribute('data-code');
    });

    // Shopify lists the newest line first (checkout included): send perks first and the gloves last,
    // so checkout reads gloves -> socks -> free perks.
    if (!document.querySelector('[data-twc-perk]')) items = PERKS.map(function (id) { return { id: id, quantity: 1 }; }).concat(items);
    items.reverse();
    items.sort(function (x, y) { return (PERKS.indexOf(x.id) > -1 ? 0 : 1) - (PERKS.indexOf(y.id) > -1 ? 0 : 1); });
    btn.classList.add('is-loading');
    btn.disabled = true;
    addToCart(items, code)
      .then(function () { syncPerksSoon(); })
      .catch(function (err) { alert(err.message); })
      .then(function () { btn.classList.remove('is-loading'); btn.disabled = false; });
  }, true);

  // socks tick row in the drawer / cart page
  document.addEventListener('change', function (e) {
    var tick = e.target.closest && e.target.closest('[data-twc-offer-tick]');
    if (!tick) return;
    var row = tick.closest('[data-twc-offer]');
    if (!row) return;
    row.classList.add('is-busy');
    var key = row.getAttribute('data-line-key');
    var job;
    if (tick.checked) {
      if (!dealOpen() && !row.hasAttribute('data-in-cart')) { tick.checked = false; row.hidden = true; return; }
      row.classList.add('is-on');
      job = addToCart([{ id: Number(row.getAttribute('data-variant')), quantity: 1 }], row.getAttribute('data-code'))
        .then(function () { if (!drawerEl()) window.location.reload(); });
    } else if (key) {
      row.classList.remove('is-on');
      job = removeLine(key);
    } else { row.classList.remove('is-busy'); return; }
    job.catch(function (err) { alert(err.message); tick.checked = !tick.checked; row.classList.remove('is-busy'); });
  });

  var lastSig = null;
  /** Cheap check on the drawer DOM: only sync when the line list actually changed. */
  function perkWatch() {
    var rows = document.querySelectorAll('#cart-drawer .cart-items__table-row');
    var sig = Array.prototype.map.call(rows, function (r) { return r.id + ':' + (r.querySelector('input') ? r.querySelector('input').value : ''); }).join('|');
    if (sig === lastSig) return false;
    var first = lastSig === null;
    lastSig = sig;
    return !first;
  }

  // reveal timed offers now and whenever the drawer re-renders
  showOffers();
  perkWatch();
  syncPerks();
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      perksLast();
      if (perkWatch()) syncPerksSoon();
      var hiddenRow = document.querySelector('[data-twc-offer][hidden]');
      if (hiddenRow && (dealOpen() || hiddenRow.hasAttribute('data-in-cart'))) showOffers();
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
